import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
const services = [{
  id: 'full-service-events',
  title: 'Full-Service Events & Weddings',
  description: 'Custom menu development and full-service catering. All set-up services include luxe decorations.',
  image: 'https://cdn.magicpatterns.com/uploads/nqueGCPVjRfVtGA7iDxeQV/image.png',
  tag: 'Celebrations'
}, {
  id: 'corporate-drop-off',
  title: 'Corporate & Drop-Off Catering',
  description: 'Elevate your meetings with our drop-off and full-service corporate catering. Luxe decorations included with set-ups.',
  image: 'https://cdn.magicpatterns.com/uploads/2W5MquAF11cS9NmPTsWQ1g/image.png',
  tag: 'Business'
}, {
  id: 'meal-prep',
  title: 'Meal Prep & Subscriptions',
  description: 'Healthy, customized meal prep and subscription services tailored for busy schedules and special dietary needs.',
  image: 'https://cdn.magicpatterns.com/uploads/wsgMXg5XYSsKVCAzFWXNDG/image.png',
  tag: 'Wellness'
}];
interface ServiceGridProps {
  onOpenQuote: (service: string) => void;
}
export function ServiceGrid({
  onOpenQuote
}: ServiceGridProps) {
  return <section id="services" className="py-16 md:py-20 bg-gray-50" data-id="element-384">
      <div className="max-w-7xl mx-auto px-6" data-id="element-385">
        <div className="text-center mb-12" data-id="element-386">
          <h2 className="text-4xl md:text-5xl mb-4" data-id="element-387">Our Service Pillars</h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-lg" data-id="element-388">
            Tailored culinary experiences designed to elevate every occasion in
            the DMV area.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-389">
          {services.map((service, index) => <motion.div key={service.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} data-id="element-390">
              <Link to={`/services/${service.id}`} className="block group cursor-pointer h-full" data-id="element-391">
                <div className="relative aspect-[3/4] overflow-hidden rounded-sm mb-6" data-id="element-392">
                  <img src={service.image} alt={service.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-393" />
                  <div className="absolute inset-0 bg-brand-black/20 group-hover:bg-brand-black/40 transition-colors duration-300" data-id="element-394" />
                  <div className="absolute top-6 left-6" data-id="element-395">
                    <span className="bg-white/90 backdrop-blur-sm text-brand-black px-4 py-1 text-[10px] font-bold uppercase tracking-widest" data-id="element-396">
                      {service.tag}
                    </span>
                  </div>
                </div>
                <h3 className="text-2xl mb-3 group-hover:text-brand-gold transition-colors" data-id="element-397">
                  {service.title}
                </h3>
                <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-398">
                  {service.description}
                </p>
                <span className="flex items-center gap-2 text-sm font-bold uppercase tracking-widest text-brand-black group-hover:text-brand-gold transition-colors" data-id="element-399">
                  Learn More <ArrowRight size={16} data-id="element-400" />
                </span>
              </Link>
            </motion.div>)}
        </div>
      </div>
    </section>;
}